import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment as appEnv } from "../../environments/environment";

@Component({
  templateUrl: "./upgrade-modal.component.html",
})
export class UpgradeModalComponent {
  @Input() public toTier: number;
  @Input() public upgradeUrl: string;

  public appEnv = appEnv;

  constructor(public activeModal: NgbActiveModal) {}
}
